/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDarkMenuItemExpandableItemCheck } from "./d-theme-dark-menu-item-expandable-item-check";

export class DThemeDarkMenuSidedItemExpandableItemCheck extends DThemeDarkMenuItemExpandableItemCheck {}
